<template>
    <div>
        <AnnouncementBanner />
        <CategoryHeroBlockContent
            :categoryId="categoryId"
            :content="categoryHeroContent"
            :categoryData="categoryData"
            class="builder-io-hero-content builder-io-content-min-height"
        />
        <SearchProductsComponent
            @criteriaChanged="searchProducts"
            :criteria="criteria"
            :searchPageContent="searchPageContent"
            :categoryPageContent="categoryContent"
            :breadcrumbData="categoryId"
            :key="categoryId"
        />
        <CategoryBottomBlockContent
            v-if="!isCapacitorEmbed"
            :categoryId="categoryId"
            :content="categoryBottomContent"
            :categoryData="categoryData"
        />
        <FooterBlockContent v-if="!isCapacitorEmbed" />
    </div>
</template>
<script>
const baseUrl = import.meta.env.VITE_BASE_URL
const apiKey = import.meta.env.VITE_APP_BUILDER_API_KEY
import { fetchEntries, fetchOneEntry, isPreviewing } from '@builder.io/sdk-vue'
import { getIsCapacitorEmbed } from '@/plugins/capacitorIframeBack'
import SearchProductsComponent from '@/components/crane/search/SearchProducts.vue'
import AnnouncementBanner from '@/components/crane/builderio/AnnouncementBanner.vue'
import CategoryBottomBlockContent from '../../components/crane/category/CategoryBottomBlockContent.vue'
import CategoryHeroBlockContent from '../../components/crane/category/CategoryHeroBlockContent.vue'
import FooterBlockContent from '../../components/crane/builderio/FooterBlockContent.vue'

import { getMeta, getCategoryOne } from '@/services/util.service'
import { mapState } from 'vuex'
export default {
    name: 'CategoryPage',
    components: {
        SearchProductsComponent,
        CategoryHeroBlockContent,
        CategoryBottomBlockContent,
        AnnouncementBanner,
        FooterBlockContent,
    },
    data: () => ({
        searchPageContent: false,
        categoryContent: null,
        categoryHeroContent: null,
        categoryBottomContent: null,
        categoryData: null,
        criteria: [
            { label: 'POSITION', value: 'position' },
            { label: 'PRODUCT NAME', value: 'name' },
            { label: 'PRICE:LOW-HIGH', value: 'price' },
            { label: 'COLOR', value: 'color' },
        ],
    }),
    metaInfo() {
        return {
            titleTemplate: `${
                this.metaData && this.metaData.title != undefined
                    ? this.metaData.title
                    : 'Crane Stationery'
            }`,
            title: `${
                this.metaData && this.metaData.title != undefined
                    ? this.metaData.title
                    : 'Crane Stationery'
            }`,
            description: `${
                this.metaData && this.metaData.description != undefined
                    ? this.metaData.description
                    : ''
            }`,
            keywords: `${
                this.metaData && this.metaData.keywords != undefined ? this.metaData.keywords : ''
            }`,

            link: [
                {
                    rel: 'canonical',
                    href: `${this.canonical ? window.location.href.split('?')[0] : baseUrl}`,
                },
            ],
        }
    },
    computed: {
        ...mapState({
            searchTerms: (state) => state.catalogBrowser.searchTerms,
            categoryProductLoadFlag: (state) => state.catalogBrowser.categoryProductLoadFlag,
        }),
        isCapacitorEmbed() {
            return getIsCapacitorEmbed()
        },
        categoryId: function () {
            return this.$route.meta.id
        },
        canonical: function () {
            return this.$route.meta.canonical
        },
        heroContent() {
            return this.$store.state.layout.heroContent
        },
        metaData() {
            return getMeta(this.heroContent.ca)
        },
        categoryList: function () {
            return this.$store.state.headerCategoryList.categoryListIdWise
        },
        categoryDetailsList: function () {
            return this.$store.state.headerCategoryList.categoryDetails
        },
    },
    watch: {
        categoryId() {
            this.createdLinkForBackButton()
            this.fetchBuilderContent()
        },
    },
    methods: {
        async createdLinkForBackButton() {
            if (
                this.$route.query.pageNumber &&
                this.$route.query.pageSize &&
                this.$route.query.sortBy &&
                this.$route.query.filter &&
                this.$route.meta.id
            ) {
                let pageNumber = Number(this.$route.query.pageNumber)
                let pageSize = this.$route.query.pageSize
                let sortBy = this.$route.query.sortBy
                let filters = {}
                try {
                    filters = JSON.parse(atob(decodeURIComponent(this.$route.query.filter)))
                } catch (err) {
                    console.error('Invalid filter JSON:', err)
                    filters = {}
                }

                let keywords = ''
                this.$store.dispatch('catalogBrowser/search', {
                    fullCatalog: window.craneCatalog,
                    keywords,
                    filters,
                    pageNumber,
                    pageSize,
                    sortBy,
                })
            } else {
                let pageNumber = 1
                let pageSize = 9
                let sortBy = 'position'
                let filters = [{ label: 'Category', prop: 'ci', value: this.categoryId }]
                let keywords = ''
                this.$store.dispatch('catalogBrowser/search', {
                    fullCatalog: window.craneCatalog,
                    keywords,
                    filters,
                    pageNumber,
                    pageSize,
                    sortBy,
                })
            }
            if (this.categoryDetailsList) {
                let categoryOne = await getCategoryOne(this.categoryDetailsList, this.categoryId)
                if (categoryOne) {
                    this.$store.dispatch('layout/setHeroContent', categoryOne)
                }
            }
        },
        searchProducts() {
            this.$store.dispatch('catalogBrowser/search', {
                fullCatalog: window.craneCatalog,
                keywords: this.searchTerms.keywords,
                filters: this.searchTerms.filters,
                pageNumber: this.searchTerms.pageNumber,
                pageSize: this.searchTerms.pageSize,
                sortBy: this.searchTerms.sortBy,
            })
            this.pushPrams({
                pageNumber: this.searchTerms.pageNumber,
                pageSize: this.searchTerms.pageSize,
                sortBy: this.searchTerms.sortBy,
                q: this.searchTerms.keywords,
                filter: btoa(JSON.stringify(this.searchTerms.filters)),
            })
        },
        fetchBuilderContent() {
            fetchOneEntry({
                model: 'category-bottom-text',
                apiKey,
                query: {
                    'data.categoryId': this.categoryId,
                },
            }).then((entry) => {
                this.categoryData = entry?.data || {}
                fetchEntries({
                    model: 'category-sections-model',
                    apiKey,
                }).then((content) => {
                    this.categoryContent = content
                    this.categoryHeroContent = content[0]
                    this.categoryBottomContent = content[1]
                })
            })
        },
        pushPrams(pushObj) {
            this.$router
                .push({
                    query: {
                        pageNumber: pushObj.pageNumber,
                        pageSize: pushObj.pageSize,
                        sortBy: pushObj.sortBy,
                        q: pushObj.q,
                        filter: pushObj.filter,
                    },
                })
                .catch((error) => {
                    error
                })
        },
    },
    async created() {
        if (
            this.$route.query.pageNumber &&
            this.$route.query.pageSize &&
            this.$route.query.sortBy &&
            this.$route.query.filter &&
            this.$route.meta.id
        ) {
            let pageNumber = Number(this.$route.query.pageNumber)
            let pageSize = this.$route.query.pageSize
            let sortBy = this.$route.query.sortBy
            let filters = JSON.parse(atob(this.$route.query.filter))

            let keywords = ''
            this.$store.dispatch('catalogBrowser/search', {
                fullCatalog: window.craneCatalog,
                keywords,
                filters,
                pageNumber,
                pageSize,
                sortBy,
            })
        } else {
            let pageNumber = 1
            let pageSize = 9
            let sortBy = 'position'
            let filters = [{ label: 'Category', prop: 'ci', value: this.categoryId }]
            let keywords = ''
            this.$store.dispatch('catalogBrowser/search', {
                fullCatalog: window.craneCatalog,
                keywords,
                filters,
                pageNumber,
                pageSize,
                sortBy,
            })
        }
        if (this.categoryDetailsList) {
            let categoryOne = await getCategoryOne(this.categoryDetailsList, this.categoryId)
            if (categoryOne) {
                this.$store.dispatch('layout/setHeroContent', categoryOne)
            }
        }
    },
    mounted() {
        this.fetchBuilderContent()
    },
}
</script>
<style lang="scss">
// for larger than mobile view
@media (min-width: 600px) {
    .builder-io-content-min-height {
        min-height: 350px;
    }
}
@media (max-width: 599px) {
    // for mobile
    .builder-io-content-min-height {
        min-height: 300px;
        // background-color: #0f172b;
    }
}
</style>
